const MyAdvantagesFooter = () => {
	return (
		<section className="myAdvantages__footer">
			<h3 className="myAdvantages__footer__heading ">
				Współpraca oparta na wartościach
			</h3>
			<p className="myAdvantages__footer-text">
				Wierzę, że te wartości sprawiają, że jestem odpowiednim partnerem do
				realizacji Twoich celów biznesowych. Jeśli cenisz profesjonalizm, pasję
				i zaangażowanie, a współpraca oparta na zaufaniu i dobrej atmosferze
				jest dla Ciebie ważna – zapraszam do współpracy!
			</p>
			<button className="btn myAdvantages__footer__btn">
				Zacznij współpracę
			</button>
		</section>
	);
};

export default MyAdvantagesFooter;
